import {WhitelabelEventWithPayload} from "../../../../common/ts/events/Events";

interface FiltersSubmittedPayload {
    formData: {},
    host?: string,
    searchParams: URLSearchParams,
    type: string,
}

export class FiltersSubmittedEvent implements WhitelabelEventWithPayload<FiltersSubmittedPayload> {
    type: string;
    static readonly MODAL_TYPE: string = 'filters-modal-submitted';
    static readonly FORM_TYPE: string = 'filters-submitted';
    payload: FiltersSubmittedPayload;

    constructor(payload: FiltersSubmittedPayload) {
        this.type = payload.type;
        this.payload = payload;
    }
}

interface FilterButtonClickedEventPayload {
    filterName?: string;
}

export class FilterButtonClickedEvent implements WhitelabelEventWithPayload<FilterButtonClickedEventPayload>{
    type: string;
    static readonly TYPE: string = 'filters-button-clicked';
    payload: FilterButtonClickedEventPayload;

    constructor(payload: FilterButtonClickedEventPayload) {
        this.type = FilterButtonClickedEvent.TYPE;
        this.payload = payload;
    }
}